import serviceHandler from "@/helpers/handlers/service";
import postsService from "@/services/gmbPosts";
import ViewHeader from "@/components/ui/ViewHeader.vue";
import PostsTabWrapper from "@/views/posts/PostsTabWrapper";
import PostsOfferForm from "@/views/posts/PostsOfferForm";
import PostsPostForm from "@/views/posts/PostsPostForm";
import PostsEventForm from "@/views/posts/PostsEventForm";
import PostsAlertForm from "@/views/posts/PostsAlertForm";
import PostsPreviewDialog from "@/views/posts/PostsPreviewDialog";
import FilterDialog from "@/components/Filter/dialog";
import FacilitiesToAddPostDialog from "@/components/Posts/dialog/FacilitiesToAddPostDialog";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import facilitiesService from "@/services/facilities";
import { pluralCount } from "@/helpers/helpers";
import { mapState, mapActions, mapGetters } from "vuex";
import PostsGuideButton from "@/views/posts/PostsGuideButton";
import cuid from "cuid";
import ErrorHandler from "@/helpers/handlers/error";
import {
  FACILITIES_FILTER_SEARCH_TYPES,
  FACILITIES_FILTER_SEARCH_TYPES_API
} from "@/enums/facilty-details-status.enum";
import { POSTS_FORM_TYPE, POSTS_CALL_TO_ACTION_TYPE } from "@/enums/posts.enum";
import AlertDialog from "@/components/ui/AlertDialog";
import { DialogHelper } from "@/helpers/dialog-helper";
import { FORMAT } from "@/config/date-format";
import moment from "moment";
import { isFeatureFlagEnabled, FEATURE_FLAG } from "@/helpers/posthog";

export const postsManageMixin = {
  components: {
    ViewHeader,
    PostsTabWrapper,
    PostsOfferForm,
    PostsPostForm,
    PostsEventForm,
    PostsAlertForm,
    PostsPreviewDialog,
    FilterDialog,
    FacilitiesToAddPostDialog,
    SectionLoader,
    PostsGuideButton,
    AlertDialog
  },
  data() {
    return {
      FEATURE_FLAG,
      searchTypes: FACILITIES_FILTER_SEARCH_TYPES,
      FACILITIES_FILTER_SEARCH_TYPES,
      POSTS_FORM_TYPE,
      loaded: false,
      imageLoader: false,
      dialog: {
        filter: false,
        viewFacilities: false,
        previewPost: false
      },
      valid: true,
      image: null,
      allFacilitiesIds: [],
      selectedFacilitiesIds: [],
      cities: [],
      facilitiesGroupsNames: [],
      facilitiesGroupsIds: [],
      searchType: null,
      searchTypeLocal: null,
      status: {
        open: 0
      },
      scheduledFacilitiesTypes: {
        [FACILITIES_FILTER_SEARCH_TYPES.FACILITIES]:
          FACILITIES_FILTER_SEARCH_TYPES_API.FACILITIES_IDS,
        [FACILITIES_FILTER_SEARCH_TYPES.FACILITIES_GROUPS]:
          FACILITIES_FILTER_SEARCH_TYPES_API.FACILITIES_GROUPS,
        [FACILITIES_FILTER_SEARCH_TYPES.CITY]:
          FACILITIES_FILTER_SEARCH_TYPES_API.CITIES
      },
      tabs: [
        {
          id: cuid(),
          name: `message.posts.add.${POSTS_FORM_TYPE.OFFER}`,
          value: 3,
          icon: "mdi-tag",
          active: true,
          hidden: false
        },
        {
          id: cuid(),
          name: `message.posts.add.${POSTS_FORM_TYPE.POST}`,
          value: 1,
          icon: "icon-edit",
          active: false,
          hidden: false
        },
        {
          id: cuid(),
          name: `message.posts.add.${POSTS_FORM_TYPE.EVENT}`,
          value: 2,
          icon: "icon-calendar",
          active: false,
          hidden: false
        },
        {
          id: cuid(),
          name: `message.posts.add.${POSTS_FORM_TYPE.ALERT}`,
          value: 4,
          icon: "icon-status-danger",
          active: true,
          hidden: true
        }
      ],
      facilitiesOptions: {
        name: "facilities",
        id: cuid(),
        required: true,
        value: 1,
        options: [
          {
            title: {
              unverified: "message.posts.facilitiesAllUnverified",
              verified: "message.posts.facilitiesAll"
            },
            tooltip: "message.posts.facilitiesAllTooltip"
          },
          {
            title: {
              unverified: "message.posts.facilitiesSelectedUnverified",
              verified: "message.posts.facilitiesSelected"
            },
            tooltip: "message.posts.facilitiesSelectedTooltip"
          }
        ]
      },
      type: 3,
      form: {},
      visibleInStoreLocator: true,
      scheduleType: null
    };
  },
  destroyed() {
    this.resetFacilitiesStore();
    this.resetFacilitiesGroupsStore();
  },
  computed: {
    getAlertType() {
      if (this.facilitiesOptions.value === 0) return undefined;

      const currentType = this.searchType || this.searchTypeLocal;

      if (currentType === this.searchTypes.FACILITIES_GROUPS) {
        return this.$t("message.posts.planning.groups");
      } else if (currentType === this.searchTypes.CITY) {
        return this.$t("message.posts.planning.cities");
      }

      return undefined;
    },
    allFacilitiesIdsList() {
      return this.allFacilitiesIds.map(({ id }) => id);
    },
    ...mapState({
      loading: state => state.company.loading
    }),
    ...mapGetters({
      hasStoreLocator: "company/hasStoreLocator"
    }),
    currentForm() {
      switch (this.type) {
        case POSTS_FORM_TYPE.POST:
          return "post";
        case POSTS_FORM_TYPE.EVENT:
          return "event";
        case POSTS_FORM_TYPE.OFFER:
          return "offer";
        case POSTS_FORM_TYPE.ALERT:
          return "covid_19_update";
        default:
          return null;
      }
    }
  },
  mounted() {
    if (
      this.$route.query.type === "fb" &&
      this.$store.state.posts.fbPostData &&
      this.$store.state.posts.fbPostData.full_picture
    ) {
      this.image = [
        {
          sourceUrl: this.$store.state.posts.fbPostData.full_picture,
          edited: false
        }
      ];
    }
  },
  methods: {
    isFeatureFlagEnabled,
    handleScheduleTypeChange(scheduleType) {
      this.scheduleType = scheduleType;
    },
    handleDeleteImage() {
      this.image = null;

      if (this.form["image_url"]) {
        delete this.form["image_url"];
      }
    },
    async getFacilitiesIds() {
      this.$store.commit("company/SET_LOADING", true);
      await this.fetchFacilitiesIds();
      this.loaded = true;
      this.$store.commit("company/SET_LOADING", false);
    },
    preparePostDateAndTime(schedule) {
      const eventDates = {};
      Object.entries(schedule).forEach(([key, date]) => {
        if (key == "start_date" || key == "end_date") {
          eventDates[key] = date
            ? moment({ ...date, month: date.month - 1 }).format(FORMAT.DATE)
            : null;
        }
        if (key == "start_time" || key == "end_time") {
          eventDates[key] = date ? moment(date).format(FORMAT.TIME) : null;
        }
      });

      return eventDates;
    },
    getFromData() {
      this.form["type"] = this.type;

      this.form["facilities_ids"] = this.allFacilitiesIds.map(({ id }) => id);

      if (this.facilitiesOptions.value !== 0) {
        this.form["facilities_ids"] = this.selectedFacilitiesIds;
      } else {
        this.form["scheduled_facilities"] = {
          facilities_all: true
        };
      }

      if (this.image && this.image[0].sourceUrl) {
        this.form["image_url"] = this.image[0].sourceUrl;
      }
      if (this.image && this.image.url) {
        this.form["image_url"] = this.image.url;
      }

      if (
        this.searchType !== null &&
        this.searchType !== FACILITIES_FILTER_SEARCH_TYPES.FACILITIES
      ) {
        this.form["scheduled_facilities"] = {
          [this.scheduledFacilitiesTypes[
            this.searchType
          ]]: this.getSelectedFacilitiesIds()
        };
        this.form["facilities_ids"] = this.selectedFacilitiesIds;
      }
      if (
        (this.searchType === FACILITIES_FILTER_SEARCH_TYPES.FACILITIES ||
          this.searchType == null) &&
        this.facilitiesOptions.value !== 0
      ) {
        this.form["scheduled_facilities"] = {
          facilities_all: false
        };
      } else if (
        this.form.scheduled_facilities &&
        this.form.scheduled_facilities.facilities_all &&
        this.facilitiesOptions.value !== 0
      ) {
        delete this.form.scheduled_facilities.facilities_all;
      }

      let formData = this.sanitize(this.form);
      if (formData.call_to_action && formData.call_to_action.type === 0) {
        delete formData.call_to_action;
      }

      Object.entries(formData).map(([key, value]) => {
        if (typeof value === "object" && !Object.keys(value).length) {
          delete formData[key];
        }
      });

      if (formData.offer) {
        Object.entries(formData.offer).map(([key, value]) => {
          if (key && value == "") {
            delete formData.offer[key];
          }
        });
      }
      if (formData.event && !formData.event.title && !formData.event.schedule) {
        delete formData.event;
      }

      if (formData.event && formData.event.schedule) {
        Object.entries(formData.event.schedule).map(([key, value]) => {
          if (typeof value === "object" && !Object.keys(value).length) {
            delete formData.event.schedule[key];
          }
        });
      }

      formData.add_to_store_locator = this.visibleInStoreLocator;
      return formData;
    },
    resetForm() {
      this.image = null;

      if (this.currentForm !== null) {
        this.$refs[this.currentForm].resetForm();
      }
    },
    requestErrorHandler(error) {
      if (error && error.response && error.response.data.facilities_ids) {
        this.$notify({
          group: "default",
          type: "error",
          text: this.$t("message.posts.facilitiesError")
        });
      } else {
        ErrorHandler.displayError(error);
      }
    },

    getFacilitiesCountLabel(count) {
      return pluralCount("message.pluralForms.facility", count);
    },

    ...mapActions({
      resetFacilitiesStore: "facilities/resetStore",
      resetFacilitiesGroupsStore: "facilitiesGroups/resetStore"
    }),
    sanitize(obj) {
      return JSON.parse(
        JSON.stringify(obj, (key, value) => {
          return value === null ? undefined : value;
        })
      );
    },
    getSelectedFacilitiesIds() {
      switch (this.searchType) {
        case FACILITIES_FILTER_SEARCH_TYPES.FACILITIES:
          return this.selectedFacilitiesIds;
        case FACILITIES_FILTER_SEARCH_TYPES.FACILITIES_GROUPS:
          return this.facilitiesGroupsNames;
        case FACILITIES_FILTER_SEARCH_TYPES.CITY:
          return this.cities;
        default:
          return null;
      }
    },
    async getImageUrl({ file, edited }) {
      if (file) {
        this.imageLoader = true;
        let formData = new FormData();
        formData.append("image", file);

        await postsService
          .getImageUrl(formData)
          .then(response => {
            this.image = [
              {
                sourceUrl: response.data.image,
                ...response.data.meta,
                edited
              }
            ];
          })
          .catch(error => {
            ErrorHandler.displayError(error);
            this.image = null;
            this.$refs[this.currentForm].$refs.cropper.resetImage();
          })
          .finally(() => {
            this.imageLoader = false;
          });
      }
    },

    showPreview() {
      this.dialog.previewPost = true;
    },

    goToGMBAccounts() {
      this.$router.push({ name: "profile-gmb-accounts" });
    },

    getFacilitiesIdsFromQuery() {
      return this.$route.query.ids
        ? this.$route.query.ids.split(",").map(id => +id)
        : [];
    },

    async fetchFacilitiesIds() {
      let results = [];
      if (!this.selectedFacilitiesIds.length) {
        results = await serviceHandler(
          facilitiesService.getFacilitiesIds({
            is_owner: true,
            is_verified: !isFeatureFlagEnabled(
              FEATURE_FLAG.GET_UNVERIFIED_FACILITIES
            ),
            facilities_ids: this.selectedFacilitiesIds,
            cities: this.cities,
            groups: this.facilitiesGroupsIds,
            open_status: this.status.open
          })
        );
      }
      if (
        this.searchType === FACILITIES_FILTER_SEARCH_TYPES.FACILITIES ||
        this.searchType === FACILITIES_FILTER_SEARCH_TYPES.CITY ||
        this.searchType === FACILITIES_FILTER_SEARCH_TYPES.FACILITIES_GROUPS
      ) {
        if (this.editMode) {
          this.isDestinationEdited = true;
        }
        this.selectedFacilitiesIds = results.length
          ? results.map(({ id }) => id)
          : this.selectedFacilitiesIds;
      } else {
        if (
          this.allFacilitiesIds.length === 0 &&
          (results.length || this.selectedFacilitiesIds.length)
        ) {
          this.allFacilitiesIds = results.length
            ? results
            : this.selectedFacilitiesIds;
        }
      }
    },

    getSelectedFacilitiesLabel() {
      let messagePath = "message.posts.selectedFacilities";

      if (this.searchType === "city") {
        messagePath = "message.posts.selectedCities";
      }

      if (this.searchType === "facilitiesGroups") {
        messagePath = "message.posts.selectedFacilitiesGroups";
      }

      return this.$t(messagePath, {
        facilitiesCount: this.getCountLabel(
          "facility",
          this.selectedFacilitiesIds.length
        ),
        citiesCount: this.getCountLabel("city", this.cities.length),
        facilitiesGroupsCount: this.getCountLabel(
          "groupGenitive",
          this.facilitiesGroupsIds.length
        )
      });
    },

    getCountLabel(type, value) {
      return pluralCount(`message.pluralForms.${type}`, value);
    },

    async onFiltersChange({
      facilitiesIds = this.selectedFacilitiesIds,
      cities = this.cities,
      facilitiesGroupsNames = this.facilitiesGroupsNames,
      facilitiesGroupsIds = this.facilitiesGroupsIds,
      openStatus = this.status.open
    }) {
      this.$store.commit("company/SET_LOADING", true);

      this.selectedFacilitiesIds = facilitiesIds;
      this.cities = cities;
      this.facilitiesGroupsNames = facilitiesGroupsNames;
      this.facilitiesGroupsIds = facilitiesGroupsIds;
      this.status.open = openStatus;

      await this.fetchFacilitiesIds();

      this.$store.commit("company/SET_LOADING", false);
    },

    closeFilterDialog() {
      this.dialog.filter = false;
    },
    openAlertDialog(publishDate) {
      DialogHelper.showDialog(
        AlertDialog,
        {
          text: !publishDate
            ? this.$t("message.posts.postSuccess")
            : this.$t("message.posts.postPlannedSuccess", [
                moment(this.form.publish_at).format(FORMAT.DDMMYYYY)
              ]),
          buttonText: this.$t("message.common.ok")
        },
        []
      );
    },
    getLocationType() {
      if (this.facilitiesOptions.value === 0) {
        return "all";
      } else if (this.searchType === FACILITIES_FILTER_SEARCH_TYPES.CITY) {
        return this.searchType;
      } else if (
        this.searchType === FACILITIES_FILTER_SEARCH_TYPES.FACILITIES_GROUPS
      ) {
        return "groups";
      } else if (
        this.searchType === FACILITIES_FILTER_SEARCH_TYPES.FACILITIES
      ) {
        return "selected";
      }
    },
    getEventParams(type, formData) {
      let eventParams = {};
      let buttonType =
        !formData.call_to_action || formData.call_to_action.type === 0
          ? "none"
          : Object.values(POSTS_CALL_TO_ACTION_TYPE)[
              formData.call_to_action.type - 1
            ];

      let buttonUrl = formData.call_to_action
        ? formData.call_to_action.url
        : null;

      switch (type) {
        case POSTS_FORM_TYPE.POST:
          eventParams.post_post = {};
          eventParams.post_post.button_type = buttonType;
          eventParams.post_post.button_url = buttonUrl;
          break;
        case POSTS_FORM_TYPE.EVENT:
          eventParams.post_event = {};
          eventParams.post_event.has_time =
            "start_time" in formData.event.schedule &&
            "end_time" in formData.event.schedule;
          eventParams.post_event.has_event_details = !!formData.text;
          eventParams.post_event.button_type = buttonType;
          eventParams.post_event.button_url = buttonUrl;
          break;
        case POSTS_FORM_TYPE.OFFER:
          eventParams.post_offer = {};
          eventParams.post_offer.has_time =
            "start_time" in formData.event.schedule &&
            "end_time" in formData.event.schedule;
          eventParams.post_offer.has_offer_details = !!formData.text;
          eventParams.post_offer.has_voucher =
            !!formData.offer && !!formData.offer.coupon_code;
          eventParams.post_offer.link_to_offer =
            !!formData.offer && formData.offer.redeem_online_url;
          eventParams.post_offer.has_terms =
            !!formData.offer && !!formData.offer.terms_conditions;
          break;
        case POSTS_FORM_TYPE.ALERT:
          eventParams.post_covid_19 = {};
          eventParams.post_covid_19.button_type = buttonType;
          eventParams.post_covid_19.button_url = buttonUrl;
          break;
        default:
          break;
      }

      return eventParams;
    }
  },
  watch: {
    "facilitiesOptions.value": {
      async handler(newValue) {
        if (newValue === 1) {
          this.dialog.filter = true;
        } else {
          this.searchType = null;
          this.dialog.filter = false;
          this.selectedFacilitiesIds = [];
          if (this.form.id && this.form.event) {
            this.allFacilitiesIds = [];
            await this.getFacilitiesIds();
            if (this.form.event.schedule) {
              this.form.event.schedule = this.preparePostDateAndTime(
                this.form.event.schedule
              );
            }
          }
        }
      }
    }
  }
};
